import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";
import { languageHelper } from "../../../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function ExpenseReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper(defaultLang, "SN") || "SN",
      cell: (row) => row.row.index + 1,
    },

    {
      header: languageHelper(defaultLang, "Date") || "Date",
      accessorKey: "date",
    },
    {
      header: languageHelper(defaultLang, "Amount") || "Amount",
      accessorKey: "amount",
    },
    {
      header: languageHelper(defaultLang, "Vat Percentage") || "Vat Percentage",
      accessorKey: "vat_percentage",
    },
    {
      header: languageHelper(defaultLang, "Vat") || "Vat",
      accessorKey: "vat",
    },
    {
      header: languageHelper(defaultLang, "Total Amount") || "Total Amount",
      accessorKey: "total_amount",
    },
    {
      header: languageHelper(defaultLang, "Tax Method") || "Tax method",
      accessorKey: "tax_method",
    },
    {
      header: languageHelper(defaultLang, "Category") || "Category",
      cell: (row) => row.row.original?.category?.name,
    },
    {
      header: languageHelper(defaultLang, "Payment Method") || "Payment Method",
      cell: (row) => row.row.original?.payment_method?.name,
    },
    {
      header: languageHelper(defaultLang, "Responsible Person") || "Responsible Person",
      cell: (row) => row.row.original?.employee?.name,
    },
    {
      header: languageHelper(defaultLang, "Note") || "Note",
      accessorKey: "note",
    },
  ];

  const footerConfig = {
    "SN": languageHelper(defaultLang, "Total") || "Total",
    "Amount": (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.amount) || 0), 0).toFixed(2),
    "Vat": (rows) =>
      rows.reduce((acc, row) => acc + (Number(row.vat) || 0), 0).toFixed(2),
    "Total Amount": (rows) => 
      rows.reduce((acc, row) => acc + (Number(row.total_amount) || 0), 0).toFixed(2),
  };

  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedPayment, setSelectedPayment] = useState();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const handlePaymentSelect = (e) => {
    setSelectedPayment(e.value);
  };

  const handleCatSelect = (e) => {
    setSelectedCategory(e.value);
  };

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const selectButton = [
    {
      placeholder: languageHelper(defaultLang, "Expense Item"),
      options: categories,
      onChange: handleCatSelect,
    },
    {
      placeholder: languageHelper(defaultLang, "Payment Method"),
      options: paymentMethods,
      onChange: handlePaymentSelect,
    },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/expensescategory`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedCat = res.data.map((cat) => ({
          value: cat.id,
          label: cat.name,
        }));
        setCategories(mappedCat);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error Occured!");
      })
      .finally(() => {});
    axios
      .get(`${apiKey}/api/rms/admin/payment_methods`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedPayments = res.data.map((payment) => ({
          value: payment.id,
          label: payment.name,
        }));
        setPaymentMethods(mappedPayments);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/expense`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          category_id: selectedCategory,
          start_date: startDate,
          payment_id: selectedPayment,
          end_date: endDate,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [
    endDate,
    selectedCategory,
    selectedOutlet,
    selectedPayment,
    startDate,
    user?.token,
    user?.user.outlet_id,
  ]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper(defaultLang, "Expense Report")}
        selectButton={selectButton}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        downloads={true}
        handleOutletSelect={handleOutletSelect}
        showFooter={true}
        footerConfig={footerConfig}
      />
    </main>
  );
}

export default ExpenseReport;
